import { compareGreater } from '@dte/otw-utils-core/src/objects/compare/compareGreater';
import { filterRecord } from '@dte/otw-utils-core/src/objects/filterRecord';
import type { MessageDetail } from '../../interfaces/api/messageDetail/MessageDetail';

export function getMessageCodesByPriority<K extends string>(map: Record<K, MessageDetail>): K[] {
	// Filter to those that have priority
	let filtered = filterRecord(map, (value) => value?.priority !== undefined);

	// Filter out any that are currently disabled
	filtered = filterRecord(filtered, (value) => !value.disabled);

	const keys = Object.keys(filtered) as K[];

	// Sort the highest priority keys first
	keys.sort((a, b) => compareGreater(filtered[a]?.priority, filtered[b]?.priority));

	return keys;
}
